'use strict';
import React from 'react';
import ReactDom from 'react-dom';
import { Link } from 'react-router-dom';
import ContractorList from './contractorList';
import contractorAction from '../../actions/contractorAction';

class ContractorBody extends React.Component {
    constructor(props) {
        super(props);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
        this.state = {
            tableWidth: 300,
            dragging: false,
            refX: 0,
            ini: 0,
            page: 0,
            contentNo: 10
        };
    }
    static defaultProps = {
        monthTxt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
    };

    componentDidMount() {
        let tableWidth = ReactDom.findDOMNode(this.refs.ctr).clientWidth;
        this.setState({
            tableWidth: tableWidth
        });
        if (document.body.clientWidth > 768) {
            let elem = ReactDom.findDOMNode(this.refs.table);
            elem.addEventListener('mouseup', this.onTouchEnd);
            elem.addEventListener('mouseleave', this.onTouchEnd);
            elem.addEventListener('mousemove', this.onTouchMove);
            elem.addEventListener('mousedown', this.onTouchStart);
            window.addEventListener('wheel', this.handleMouseScroll);
        }
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        if (document.body.clientWidth > 768) {
            let elem = ReactDom.findDOMNode(this.refs.table);
            elem.removeEventListener('mouseup', this.onTouchEnd);
            elem.removeEventListener('mouseleave', this.onTouchEnd);
            elem.removeEventListener('mousemove', this.onTouchMove);
            elem.removeEventListener('mousedown', this.onTouchStart);
            window.removeEventListener('wheel', this.handleMouseScroll);
        }
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.contractors != this.props.contractors) {
            this.setState({
                page: 0
            });
        }
    }
    handleMouseScroll(e) {
        
        e.preventDefault();

        if (e.deltaY > 0) {
            //scroll down
            window.scrollBy(0, 50);
        } else {
            //scroll up
            window.scrollBy(0, -50);
        }
        

    }
    handleScroll(e) {
        let elem1 = ReactDom.findDOMNode(this.refs.ctr);
        let elem2 = ReactDom.findDOMNode(this.refs.table);
        if (elem2.getBoundingClientRect().top < 50) {

            elem1.style.position = "absolute";
           
            if (document.body.clientWidth > 768) {
                elem2.style.paddingTop="50px";
                elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
            } else {
                elem2.style.paddingTop="0px";
                elem1.style.top = -elem2.getBoundingClientRect().top + "px";
            }
        } else {
            elem1.style.position = "relative";
            elem1.style.top = "0px";
            elem2.style.paddingTop="0px";
        }

    }
    onTouchStart(e) {
        if (!this.state.dragging) {
            let touches = e.changedTouches;
            let refX;
            if (e.touches) {
                refX = e.touches[0].clientX;
            } else {
                refX = e.clientX;
            }
            let ini = ReactDom.findDOMNode(this.refs.table).scrollLeft;
            this.setState({
                ini: ini,
                refX: refX,
                dragging: true,
            });
        } else {
            this.setState({
                dragging: false
            });
        }
    }

    onTouchMove(e) {
        e.preventDefault();
        if (this.state.dragging && e.target) {
            let deltaX;
            if (e.touches) {
                deltaX = parseInt(this.state.refX - e.touches[0].clientX);
            } else {
                deltaX = parseInt(this.state.refX - e.clientX);
            }

            ReactDom.findDOMNode(this.refs.table).scrollLeft = (this.state.ini + deltaX);
        } else {
            this.setState({
                dragging: false
            });
        }
    }

    onTouchEnd(e) {
        this.setState({
            dragging: false,
        });
    }
    handleClick(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index'));

        if (index != this.state.page) {
            this.setState({ page: index });
        }
    }
    renderPagination() {
        if (!this.props.contractors) return;
        if (this.props.contractors.length == 0) return;

        let pageNo = Math.ceil(this.props.contractors.length / this.state.contentNo);

        let pagination = [];
        for (let i = 0; i < pageNo; i++) {
            pagination = pagination.concat(
                <li className={this.state.page == i ? "active" : ""} key={i} data-index={i} onClick={this.handleClick}>
                    <a href="#" >{i + 1}</a>
                </li>
            );
        }
        return (
            <nav className="ctr-pg">
                <ul className="pagination">
                    {pagination}
                </ul>
                <div className="pagination-title">page {(this.state.page + 1) + " of " + pageNo}</div>
            </nav>
        )
    }
    render() {
        let contractors = [];
        for (let i = 0 + this.state.contentNo * this.state.page; i < this.state.contentNo + this.state.contentNo * this.state.page; i++) {
            if (i < this.props.contractors.length) {
                contractors = contractors.concat(this.props.contractors[i]);
            }
        }

        return (
            <div>
                {this.renderPagination()}
                <div className="est-bd-wp" ref="table">

                    <div className="ctr-bd">
                        <table className="ctr-tb tb-heading" ref="ctr">
                            <thead>
                                <tr>
                                    <th>MCST</th>
                                    <th>Estate</th>
                                    <th>No of Units</th>
                                    <th>Address</th>
                                    <th>ManageBy</th>
                                    <th>Manager</th>
                                    <th>Contractor</th>
                                    <th>Service</th>
                                    <th>Description</th>
                                    <th>Last Visit</th>
                                    <th>Contractor Address</th>
                                    <th>Contact Name</th>
                                    <th>Telephone</th>
                                    <th>Fax</th>
                                    <th>Contractor Email</th>
                                    <th>Status</th>
                                    <th>Contract Start Date</th>
                                    <th>Contract End Date</th>
                                    <th>First Reminder</th>
                                    <th>Second Reminder</th>
                                    <th>Contract Due In (days)</th>
                                    <th>Amount</th>
                                    <th>Remark</th>
                                </tr>
                            </thead>
                        </table>
                        <ContractorList contractors={contractors} tableWidth={this.state.tableWidth}
                            page={this.state.page} contentNo={this.state.contentNo} />
                    </div>

                </div>
                {this.renderPagination()}
            </div>
        );
    }
}
export default ContractorBody;


// WEBPACK FOOTER //
// ./app/setComponents/contractorComponents/contractorBody.js